

exports.__esModule = true;
exports.$GuestAuthNodeRoute = void 0;
var _squid = require("squid");
require("./directive");
var $GuestAuthNodeRoute = exports.$GuestAuthNodeRoute = _squid.$ComponentRoute.extend('$GuestAuthNodeRoute', {
  path: 'guestauthnode',
  directive: 'xo-guest-authnode',
  trackingData: {},
  children: []
});
angular.value("$GuestAuthNodeRoute", $GuestAuthNodeRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-guest-components/src/guest-authnode/route.js
// module id = ../node_modules/xo-guest-components/src/guest-authnode/route.js
// module chunks = 0